 function priceFormat(number) {
     console.log(number);
    let round = JSON.parse(localStorage.getItem('sale')).price.round;
    //функция приводит сумму в нужный формат
    var number = number.toFixed(round);
    var str = JSON.parse(localStorage.getItem('sale')).price.mask.split('');
    var outputStr = str.map(function(el) {
        if(el === '#') {
            return number;
        } else {
            return el;
        }
    });
    // console.log(number);
    return outputStr.join('');
}

module.exports = priceFormat;


// WEBPACK FOOTER //
// ./libs/price-format/price-format.js